'use client';

import { filterBlank } from '@dte/otw-utils-core/src/lists/filterEmpty';
import { getArray } from '@dte/otw-utils-core/src/lists/mergeArrays';
import { uniqueValues } from '@dte/otw-utils-core/src/lists/uniqueValues';
import { normalizeValues } from '@dte/otw-utils-core/src/strings/normalizeValues';

export function joinClasses(...classes: Array<string | undefined>): string {
	let classNames = getArray(classes);

	// Seprate the classes by spaces
	classNames = classNames.join(' ').split(' ');

	// Make sure we have only unique values
	classNames = normalizeValues(classNames);
	classNames = uniqueValues(classNames);

	const filtered = filterBlank(classNames);
	return filtered.join(' ');
}

export function addClassName(existingClassName: string | undefined, className: string | undefined): string {
	return joinClasses(existingClassName, className);
}
